module.exports = __webpack_public_path__ + "2106d173069dbc6ebc40881d69532a0e.svg";